/**
 * cn — concatena classes condicionalmente.
 * Versão leve (sem dependências) suficiente para o UI kit:
 * filtra valores falsy e junta com espaço.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
